import { 
    page
} from '@/api/member-buy-record.js'

export default {
  state: {
    list: [],
    pageNum: 1,
    pageSize: 10,
    total: 0,
    memberBuyRecordLoading: false
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setMemberBuyRecordLoading (state, loading) {
      state.memberBuyRecordLoading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
  },
  getters: {
    memberBuyRecordList: state => state.list,
    memberBuyRecordTotal: state => state.total,
    memberBuyRecordLoading: state => state.memberBuyRecordLoading
  },
  actions: {
    getMemberBuyRecordPage ({ state, commit }, param) {
      commit('setMemberBuyRecordLoading', true)
      return new Promise((resolve, reject) => {
        page(param).then(res => {
          const data = res.data.result
          const list = data.records
          const total = data.total
          const pageNum = data.pageNum
          const pageSize = data.pageSize
          commit('setList', list)
          commit('setTotal', total)
          commit('setPageNum', pageNum)
          commit('setPageSize', pageSize)
          commit('setMemberBuyRecordLoading', false)
          resolve()
        }).catch(err => {
          commit('setMemberBuyRecordLoading', false)
          reject(err)
        })
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/module/member-buy-record.js